var React = require('react');

function FilterDownIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.5 7L0.602886 0.250001L8.39711 0.25L4.5 7Z","fill":"black"}));
}

FilterDownIcon.defaultProps = {"width":"9","height":"7","viewBox":"0 0 9 7","fill":"none"};

module.exports = FilterDownIcon;

FilterDownIcon.default = FilterDownIcon;
